class CollectionInfiniteScroll {
    constructor(container) {
        this.container = container;
        this.sectionId = container.dataset.sectionId;
        this.root = container.closest('[data-infinite-root]');
        this.grid = this.root ? this.root.querySelector('[data-products-grid]') : null;
        this.sentinel = container.querySelector('[data-infinite-sentinel]');
        this.loadingEl = container.querySelector('[data-infinite-loading]');
        this.nextUrl = container.dataset.nextUrl || '';
        this.isLoading = false;
        this.observer = null;

        if (!this.root || !this.grid || !this.sentinel || !this.nextUrl) {
            if (!this.nextUrl) {
                this.container.hidden = true;
            }
            return;
        }

        this.initObserver();
    }

    initObserver() {
        this.observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        this.loadNextPage();
                    }
                });
            },
            {
                rootMargin: '300px 0px'
            }
        );

        this.observer.observe(this.sentinel);
    }

    async loadNextPage() {
        if (this.isLoading || !this.nextUrl) return;

        this.isLoading = true;
        if (this.loadingEl) this.loadingEl.hidden = false;

        try {
            const separator = this.nextUrl.includes('?') ? '&' : '?';
            const url = `${this.nextUrl}${separator}section_id=${this.sectionId}`;

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            });

            if (!response.ok) {
                throw new Error(`Request failed with status ${response.status}`);
            }

            const html = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            const newRoot = doc.querySelector(`[data-infinite-root][section-id="${this.sectionId}"]`);
            const newGrid = newRoot ? newRoot.querySelector('[data-products-grid]') : null;
            const newScroll = newRoot ? newRoot.querySelector('[data-infinite-scroll]') : null;

            if (!newGrid) {
                this.finish();
                return;
            }

            Array.from(newGrid.children).forEach((item) => {
                this.grid.appendChild(item);
            });

            this.nextUrl = newScroll ? (newScroll.dataset.nextUrl || '') : '';
            this.container.dataset.nextUrl = this.nextUrl;

            if (!this.nextUrl) {
                this.finish();
            }
        } catch (error) {
            console.error('Infinite scroll load failed:', error);
            this.finish();
        } finally {
            this.isLoading = false;
            if (this.loadingEl) this.loadingEl.hidden = true;
        }
    }

    finish() {
        this.nextUrl = '';
        this.container.dataset.nextUrl = '';
        this.container.hidden = true;

        if (this.observer) {
            this.observer.disconnect();
        }
    }
}

function initCollectionInfiniteScroll(scope = document) {
    const nodes = scope.querySelectorAll('[data-infinite-scroll]:not([data-infinite-ready])');

    nodes.forEach((node) => {
        node.dataset.infiniteReady = 'true';
        new CollectionInfiniteScroll(node);
    });
}

document.addEventListener('DOMContentLoaded', () => {
    initCollectionInfiniteScroll();
});

const domObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
            if (!(node instanceof HTMLElement)) return;

            if (node.matches && node.matches('[data-infinite-scroll]')) {
                initCollectionInfiniteScroll(node.parentNode || document);
            } else if (node.querySelector) {
                initCollectionInfiniteScroll(node);
            }
        });
    });
});

domObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
});